<rask-fieldset-toggle
    [formGroup]="form"
    label="Destinerade mott.platser"
    [defaultExpanded]="open"
    [nrOfSelectedFilters]="filterLength">
    <rask-multi-selector
        label="Destinerade mottagningsplatser"
        bindValue="key"
        bindLabel="value"
        class="w-100"
        [items]="items"
        formControlName="mottagningsplats"
        [selected]="control.value"
        [portalToBody]="true"
        [searchFn]=keyValueSearchFn>
    </rask-multi-selector>
</rask-fieldset-toggle>